import React from "react";

function SkeletonBlock({ className = "", style }) {
  return (
    <span
      className={`dti-skeleton ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
}

export function DtiSkeletonToolbar({ showExport = false }) {
  return (
    <div className="dti-toolbar dti-skeleton-toolbar" aria-busy="true" aria-label="Đang tải">
      <SkeletonBlock className="dti-skeleton-toolbar__hint" />
      <div className="dti-toolbar__actions">
        <SkeletonBlock className="dti-skeleton-toolbar__btn" />
        {showExport && <SkeletonBlock className="dti-skeleton-toolbar__btn" />}
      </div>
    </div>
  );
}

export function DtiSkeletonPagesBar() {
  return (
    <div className="dti-pages-bar dti-skeleton-pages-bar" aria-hidden="true">
      <SkeletonBlock className="dti-skeleton-pages-bar__btn" />
    </div>
  );
}

export function DtiSkeletonKpiGrid({ count = 3 }) {
  return (
    <div className="dti-kpi-grid" aria-busy="true" aria-label="Đang tải chỉ số">
      {Array.from({ length: count }, (_, index) => (
        <div className="dti-kpi-card dti-skeleton-kpi-card" key={index}>
          <SkeletonBlock className="dti-skeleton-kpi-card__value" />
          <SkeletonBlock className="dti-skeleton-kpi-card__label" />
        </div>
      ))}
    </div>
  );
}

export default function DtiOverviewSkeleton({
  kpiCount = 3,
  showExport = false,
}) {
  return (
    <div className="dti-overview-skeleton">
      <DtiSkeletonToolbar showExport={showExport} />
      <DtiSkeletonPagesBar />
      <DtiSkeletonKpiGrid count={kpiCount} />
    </div>
  );
}
